import React from "react";
import Carousel1 from "../images/carousel-img1.jpg";
import Carousel2 from "../images/carousel-img2.jpg";
import Carousel3 from "../images/carousel-img3.jpg";

export default function Carousel() {
  return (
    <div
      id="carouselExampleCaptions"
      className="carousel slide"
      data-ride="carousel"
    >
      <ol className="carousel-indicators">
        <li
          data-target="#carouselExampleCaptions"
          data-slide-to="0"
          className="active"
        ></li>
        <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
        <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
      </ol>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src={Carousel1}
            className="d-block w-100"
            alt="Mother with a sick child"
          />
          <div className="carousel-caption d-none d-md-block">
            <h2>Simple, Secure, Telemedicine Software</h2>
            <p>
              Offer your patients top-class solutions with Video Calls, Care
              Plans, Secure Messaging and more.
            </p>
          </div>
        </div>
        <div className="carousel-item">
          <img src={Carousel2} className="d-block w-100" alt="..." />
          <div className="carousel-caption d-none d-md-block">
            <h2>A complete Practice Management Software</h2>
            <p>
              Everything your staff needs to manage their daily medical practice
              the smart way
            </p>
          </div>
        </div>
        <div className="carousel-item">
          <img src={Carousel3} className="d-block w-100" alt="..." />
          <div className="carousel-caption d-none d-md-block">
            <h2>Top Medical Practice + Telemedicine = Patient Engagement</h2>
            <p>
              Don't be left out. Get your own mobile app, patient portal, online
              appointment bookings, patient records, practice management and
              telemedicine - all included.
            </p>
          </div>
        </div>
      </div>
      <a
        className="carousel-control-prev"
        href="#carouselExampleCaptions"
        role="button"
        data-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a
        className="carousel-control-next"
        href="#carouselExampleCaptions"
        role="button"
        data-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
  );
}
